
export default function Outcomes() {
  const outcomes = [
    { title: 'Unified Platform Adoption', description: 'Organizations successfully migrated from seven disconnected systems to a single platform', icon: 'ri-check-double-line', stat: '7→1' },
    { title: 'Improved Compliance', description: 'Automated audit trails and role-based access controls improved regulatory compliance', icon: 'ri-shield-check-line', stat: '100%' },
    { title: 'Reduced Cognitive Load', description: 'Consistent navigation and interaction patterns reduced context-switching friction', icon: 'ri-brain-line', stat: '-60%' },
    { title: 'Scalable Architecture', description: 'Design system enabled rapid deployment of new features without compromising consistency', icon: 'ri-rocket-line', stat: '3x' }
  ];

  const learnings = [
    { title: 'Enterprise UX Requires Deep Domain Understanding', description: 'Designing for construction workflows required extensive time on job sites, observing real work patterns, and understanding regulatory requirements.' },
    { title: 'Progressive Disclosure Balances Power and Simplicity', description: 'Rather than building separate interfaces for different skill levels, progressive disclosure allowed a single interface to serve both novice and expert users.' },
    { title: 'Design Systems Are Critical for Multi-Module Platforms', description: 'Investing in a robust design system early in the project paid significant dividends as the platform scaled.' }
  ];

  return (
    <section className="py-20" style={{ background: 'linear-gradient(180deg, #182423 0%, #2a3d3b 100%)' }}>
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 rounded-full text-sm font-semibold mb-4" style={{ backgroundColor: '#F16051', color: 'white' }}>
            Results
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Outcomes & Impact
          </h2>
          <p className="text-xl text-white/70 max-w-3xl mx-auto">
            Measuring the success of our design decisions through real-world results
          </p>
        </div>

        {/* Outcome Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16">
          {outcomes.map((outcome, index) => (
            <div key={index} className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/10 text-center group hover:bg-white/20 transition-all duration-300">
              <div className="w-12 h-12 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300" style={{ backgroundColor: '#F16051' }}>
                <i className={`${outcome.icon} text-white text-xl`}></i>
              </div>
              <div className="text-3xl font-black text-white mb-2">{outcome.stat}</div>
              <h4 className="text-sm font-bold text-white mb-1">{outcome.title}</h4>
              <p className="text-xs text-white/60">{outcome.description}</p>
            </div>
          ))}
        </div>

        {/* Key Learnings */}
        <div className="bg-white rounded-3xl p-8 md:p-12 mb-12">
          <h3 className="text-2xl font-bold mb-8" style={{ color: '#182423' }}>Key Learnings</h3>
          <div className="space-y-6">
            {learnings.map((learning, index) => (
              <div key={index} className="flex gap-6 items-start">
                <div 
                  className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: index % 2 === 0 ? '#F16051' : '#182423' }}
                >
                  <span className="text-white font-bold">{index + 1}</span>
                </div>
                <div>
                  <h4 className="text-lg font-bold text-gray-900 mb-2">{learning.title}</h4>
                  <p className="text-gray-600 leading-relaxed">{learning.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Reflections */}
        <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-white/10">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{ backgroundColor: '#F16051' }}>
              <i className="ri-lightbulb-flash-line text-white text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-white">Reflections</h3>
          </div>
          <p className="text-white/80 leading-relaxed mb-4">
            SureWorx demonstrated that enterprise B2B SaaS platforms can be both powerful and intuitive. By focusing on real user workflows, designing for scalability, and maintaining consistency across modules, we created a platform that serves diverse user needs without sacrificing usability.
          </p>
          <p className="text-white/80 leading-relaxed">
            The project reinforced the importance of deep domain expertise in enterprise UX design. Understanding the construction industry's unique challenges—regulatory complexity, hierarchical organizations, and field-based work—was essential to creating solutions that truly addressed user needs rather than imposing generic patterns.
          </p>
        </div>

        {/* Back to Portfolio */}
        <div className="text-center mt-12">
          <a 
            href="/" 
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full font-semibold text-white transition-all duration-300 hover:scale-105"
            style={{ backgroundColor: '#F16051' }}
          >
            <i className="ri-arrow-left-line"></i>
            Back to Portfolio
          </a>
        </div>
      </div>
    </section>
  );
}
